import FacebookNew from 'social/facebook-new.svg';
import Facebook from 'social/facebook.svg';
import Google from 'social/google.svg';
import Instagram from 'social/instagram.svg';
import LinkedIn from 'social/linkedin.svg';
import Twitter from 'social/twitter.svg';
import Youtube from 'social/youtube.svg';

export const SocialIconComponentByName = {
  facebook: Facebook,
  'facebook-new': FacebookNew,
  twitter: Twitter,
  linkedin: LinkedIn,
  youtube: Youtube,
  instagram: Instagram,
  google: Google,
} as const;

export type SocialIconName = keyof typeof SocialIconComponentByName;
